/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter, Link } from 'react-router-dom';

import ReactHoverObserver from 'react-hover-observer';

import ReactPlayer from 'react-player';
// import HTMLEllipsis from "react-lines-ellipsis/lib/html";
import axios from 'axios';

import moment from 'moment';
import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

import { Modal } from 'react-responsive-modal';
//mport Modal from 'react-modal';
import UsePoint from '../containers/point/UsePoint';
// import Items from '../pages/Items';
import Tooltip from '@material-ui/core/Tooltip';
import parse from 'html-react-parser';
import { Base64 } from 'js-base64';
import { isMobile, isAndroid, isIOS } from 'react-device-detect';

// import { ModalRoute } from 'react-router-modal';
// import 'react-router-modal/css/react-router-modal.css';

class ContentItem extends Component {
  state = {
    mouseOn: false,
    showItem: false,
    wishFlag: this.props.childProps.wishFlag
      ? this.props.childProps.wishFlag
      : 0,
    playIcon: false,
    modalShow: false,
    payGubun: '',
  };
  path = '';
  componentDidMount = () => {
    const { history } = this.props;
    this._getWindowSize();

    window.addEventListener('resize', this._getWindowSize);

    this.path = history.location.pathname;
  };
  componentWillUnmount = () => {
    window.removeEventListener('resize', this._getWindowSize);
  };
  _getWindowSize = () => {
    ////console.log(window.innerWidth)
    //const hSize = (window.innerWidth-18) * (322/181)
    ////console.log('hSize')
    ////console.log(hSize)

    // 282 * 407  493 * 468

    const wSize = parseInt(window.innerWidth - 17) / parseFloat(6.5);
    const wSizeOver = parseInt(window.innerWidth - 18) / parseFloat(3.89);
    const hSize = wSizeOver * (287 / 493);
    const hSize1 = wSizeOver * (282 / 350);
    // const hSizeOrver = wSizeOver * (278 / 493);

    const fSize = parseInt(window.innerWidth - 18) / parseFloat(120);
    const fSizeSmail = parseInt(window.innerWidth - 18) / parseFloat(160);
    ////console.log(window.innerWidth-1)
    ////console.log(wSize)
    //493 * 287 도영상
    this.setState({
      wSize: wSize, //wSize > 282 ? 282 : wSize
      wSizeOver: wSizeOver, // wSizeOver > 489 ? 489 : wSizeOver
      hSize: hSize,
      hSize1: hSize1,
      fSize: fSize > 16 ? 16 : fSize,
      fSizeSmail: fSizeSmail > 12 ? 12 : fSizeSmail,
    });
  };

  _goItem = (contentSerial) => {
    const { history, match } = this.props;
    console.log(this.path);
    console.log(match);
    // history.push('/items/' + contentSerial);
  };

  _onToggelMouseOn = (e) => {
    ////console.log('aaaa')
    e.stopPropagation();
    //setTimeout(() => {
    this.setState({
      mouseOn: true,
    });
    //}, 700)
  };
  _onToggelMouseOut = (e) => {
    ////console.log('bbb')
    e.stopPropagation();
    this.setState({
      mouseOn: false,
    });
  };
  _timeToMs = (time) => {
    const tt = time.split(':');
    const sec =
      parseInt(tt[0]) * 3600 + parseInt(tt[1]) * 60 + parseInt(tt[2]) * 1;
    return sec;
    ////console.log(sec)
  };
  _moreItem = () => {
    const { history, setContentSerial } = this.props;
    const { contentSerial } = this.props.childProps;
    //console.log(contentSerial)
    //history.push('/items/' + contentSerial)
    //console.log(this.path)

    if (this.path === '/live') {
      if (this.props.contentSerial > 0) {
        //console.log('삭제 후 이동')
        setContentSerial(0);

        setTimeout(() => {
          setContentSerial(contentSerial);
        }, 300);
      } else {
        //console.log('이동')
        setContentSerial(contentSerial);
      }
    } else {
      if (this.props.contentSerial > 0) {
        //console.log('삭제 후 이동')
        setContentSerial(0);

        setTimeout(() => {
          history.push('/items/' + contentSerial);
        }, 300);
      } else {
        //console.log('이동')
        history.push('/items/' + contentSerial);
      }
    }
  };
  _onCloseItem = () => {
    this.setState({
      showItem: false,
    });
  };
  _onPlay = async (e) => {
    const { history, loginId, setPlayUrl, setContentSerial, aParam, match } =
      this.props;
    const { contentPartSerial, contentSerial } = this.props.childProps;

    let target;
    if (e) {
      target = e.currentTarget.className;
      e.stopPropagation();
    } else {
      target = 'list_img_play';
    }

    if (target === 'list_img_bg' || target === 'list_text_group') {
      if (this.path === '/live') {
        if (this.props.contentSerial > 0) {
          //console.log('삭제 후 이동')
          setContentSerial(0);

          setTimeout(() => {
            setContentSerial(contentSerial);
          }, 300);
        } else {
          //console.log('이동')
          setContentSerial(contentSerial);
        }
      } else {
        if (this.props.contentSerial > 0) {
          //console.log('삭제 후 이동')
          setContentSerial(0);

          setTimeout(() => {
            history.push('/items/' + contentSerial);
          }, 300);
        } else {
          //console.log('이동')
          // alert(0);
          // console.log(match);
          // history.push(`/items/${contentSerial}`);
          history.push('/items/' + contentSerial);
        }
      }
    } else if (target === 'list_img_play' || target === 'list_title') {
      if (loginId === '' || loginId === undefined || loginId === null) {
        toast.warn('로그인후 관람이 가능합니다.');
        history.push('/login');
        return false;
      } else {
        if (
          contentPartSerial === undefined ||
          contentPartSerial === null ||
          contentPartSerial === ''
        ) {
          toast.warn('파라메터가 누락되었습니다.');
        } else {
          const result = await this._onGetSubPartSerialApi();
          if (result) {
            const intReturn = result.data[0].intReturn;
            const subData = result.data[0].listData;

            if (intReturn === 0) {
              const subPartSerial2 = subData[0].subPartSerial2;
              const subPartSerial3 = subData[0].subPartSerial3;
              const part = subData[0].part;

              this.setState({
                subData,
              });
              const date = new Date();
              const timeStemp = moment(date)
                .add(10, 'minutes')
                .format('YYYYMMDDHHmmss');
              //let param = this.encode(timeStemp)

              //let crypParam = timeStemp + '|aniplus|' + subPartSerial2 + '/' + loginId
              let crypParam =
                timeStemp +
                '|was|' +
                subPartSerial2 +
                '/' +
                loginId +
                '@' +
                aParam;
              const base64Data = await this._getBase64Encode(crypParam);
              crypParam = base64Data.data.codeString;

              let urlEncode =
                contentPartSerial +
                '|' +
                subPartSerial2 +
                '|' +
                subPartSerial3 +
                '|' +
                part;
              const base64Data1 = await this._getBase64Encode(urlEncode);
              urlEncode = base64Data1.data.codeString;

              const result = await this._onPlayApi(subPartSerial2, crypParam);
              if (result) {
                const intReturn = result.data[0].intReturn;
                //console.log(intReturn)
                if (intReturn === 0 || intReturn === 10) {
                  //onCloseModal()

                  setPlayUrl(urlEncode);
                  //history.push('/player/?u=' + urlEncode)
                } else if (intReturn === -7 || intReturn === -1) {
                  alert('서비스 중인 콘텐츠가 아닙니다.');
                } else if (intReturn === -4 || intReturn === -5) {
                  //alert('이용권 또는 포인트 구매 후 관람이 가능합니다.')
                  toast.warn('이용권 또는 포인트 충전후 관람이 가능합니다');
                } else if (intReturn === -2) {
                  alert('19세 미만은 관람이 불가한 작품입니다.');
                } else if (intReturn === -3) {
                  //포인트 결제창 뛰울것
                  this._onShowModal('vod');
                } else {
                  // alert("오류가 발생했습니다.");
                }
              }
            } else {
              toast.error('재생 정보가 존재하지 않습니다.');
            }
          }
        }
      }
    }
    //console.log('play')
  };
  _onGetSubPartSerialApi = () => {
    const { apiUrl } = this.props;
    const { contentPartSerial } = this.props.childProps;

    return axios
      .post(apiUrl + '/getSubPartSerial', {
        params: {
          contentPartSerial: contentPartSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        toast.error('오류가 발생했습니다.');
        //alert('오류가 발생했습니다.')
      });
  };

  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return value ? value[2] : null;
  };

  _onPlayApi = (subPartSerial, crypParam) => {
    const { apiUrl, loginId, authId, history } = this.props;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');

    let token = new Date();
    token = moment(token).format('YYYYMMDDhhmmss');
    token = Base64.encode(token);

    return axios
      .post(
        apiUrl + '/vodUrl',
        {
          params: {
            userid: loginId,
            authId: authId,
            subPartSerial: subPartSerial,
            //param: param,
            crypParam: crypParam,
            token: token,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(0);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _toggleWish = async () => {
    const { onInit } = this.props.childProps;
    const { loginId, history } = this.props;
    // const { wishFlag } = this.state;

    //console.log(contentSerial, wishFlag)

    if (loginId === '' || loginId === null || loginId === undefined) {
      toast.warn('로그인 후 이용이 가능합니다.');
      history.push('/login');
    } else {
      const result = await this._toggleWishApi();
      const intReturn = result.data[0].intReturn; // 0 삭제됨 100 추가됨

      this.setState({
        wishFlag: intReturn,
      });
      //console.log(intReturn)
      if (intReturn === 0) {
        if (onInit) {
          setTimeout(() => {
            onInit(1);
          }, 700);
        }
      }
    }
  };
  _toggleWishApi = () => {
    const { apiUrl, loginId } = this.props;
    const { contentSerial } = this.props.childProps;

    return axios
      .post(apiUrl + '/wishToggle', {
        params: {
          userid: loginId,
          contentSerial: contentSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        toast.error('오류가 발생했습니다.');
        //alert('오류가 발생했습니다.')
      });
  };
  _togglePlayOn = () => {
    const { playIcon } = this.state;
    this.setState({
      playIcon: !playIcon,
    });
  };
  _getBase64Encode = (codeString) => {
    const { aspUrl, pkg, loginId } = this.props;
    return axios(
      aspUrl +
        '/base64encode_wd.asp?codeString=' +
        codeString +
        '&p=' +
        pkg +
        '&i=' +
        loginId
    )
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _getBase64Decode = (codeString) => {
    const { aspUrl } = this.props;
    //console.log(aspUrl + '/base64decode.asp?codeString=' + codeString)
    return axios(aspUrl + '/base64decode.asp?codeString=' + codeString)
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _onHoverChange = (isHovering) => {
    const { num, onEndItemSlide, onChangeWidth } = this.props.childProps;
    if (onEndItemSlide) {
      onEndItemSlide(num, isHovering.isHovering);
    }

    if (onChangeWidth) {
      onChangeWidth(num, isHovering.isHovering);
    }
  };
  _onShowModal = (payGubun) => {
    //alert(0)
    this.setState({
      payGubun: payGubun,
      modalShow: true,
    });
  };
  _onCloseModal = () => {
    this.setState({
      modalShow: false,
    });
  };
  _setPointUse = async () => {
    const { loginId } = this.props;
    const { payGubun } = this.state;

    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._setPointUseApi();
      if (result) {
        const intReturn = result.data[0].intReturn;
        if (intReturn === 0) {
          this.setState({
            modalShow: false,
          });
          if (payGubun === 'down') {
            this._onDownload();
          } else {
            this._onPlay();
          }

          ////console.log('다운로드 시작.')
        }
      }
    }
  };
  _setPointUseApi = () => {
    const { payGubun, subData } = this.state;
    const { contentSerial } = this.props.childProps;

    const { apiUrl, loginId, authId, history } = this.props;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    const subPartSerial2 = subData[0].subPartSerial2;
    // const subPartSerial3 = subData[0].subPartSerial3;

    //console.log(apiUrl + '/setUsePoint?userid=' + loginId + '&CheckedItems=' + subPartSerial2 + ',' + '&contentSerial=' + contentSerial + '&gubun=' + payGubun )
    //return axios(apiUrl + '/setUsePoint?userid=' + loginId + '&CheckedItems=' + subPartSerial2 + ',' + '&contentSerial=' + contentSerial + '&gubun=' + payGubun + '&chksale=ppv' )
    return axios
      .post(
        apiUrl + '/setUsePoint',
        {
          params: {
            userid: loginId,
            authId: authId,
            CheckedItems: subPartSerial2 + ',',
            contentSerial: contentSerial,
            gubun: payGubun,
            chksale: 'ppv',
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //toast.error('포인트 정보를 로드중 오류가 발생했습니다.')
        //alert('포인트 정보를 로드중 오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(1);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async (gubun) => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');

    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      if (gubun === 0) {
        this._onPlay();
      } else if (gubun === 1) {
        this._setPointUse();
      }
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  render() {
    // const { loginId } = this.props;
    const {
      wSize,
      wSizeOver,
      hSize,
      hSize1,
      hSizeOrver,
      wishFlag,
      playIcon,
      modalShow,
      payGubun,
      subData,
    } = this.state;
    const { imgUrl, match, serviceEndDate } = this.props;
    const {
      contentSerial,
      contentPartSerial,
      title,
      genreName,
      img,
      overImg,
      restrictionCode,
      opening,
      director,
      contentSysnopsis,
      dRank,
      refer,
      subTitle,
      cashOnly,
    } = this.props.childProps;
    ////console.log(dRank)
    //const synopsis = "<p>" + contentSysnopsis + "</p>"
    ////console.log(wishFlag)
    // const regex = /<p>/gi;
    //const result = contentSysnopsis.replace(/(<br>|<br\/>)/gi, '');
    let result = contentSysnopsis.replace(/(br)/gi, '');
    result = result.replace(/(< \/>)/gi, '');
    //const result = contentSysnopsis.replace(/<p>/ig, '');

    // const customStyles = {
    //   content: {
    //     top: 150,
    //     backgroundColor: "black",
    //   },
    // };
    return (
      <Fragment>
        <ReactHoverObserver
          hoverDelayInMs={300}
          hoverOffDelayInMs={300}
          onHoverChanged={this._onHoverChange}
        >
          {({ isHovering }) => (
            <div
              className={isHovering ? 'list_paly2_on div_li' : 'div_li'}
              style={
                isHovering
                  ? isMobile
                    ? null
                    : {
                        transition: 'all ease 0.5s',
                        width: wSizeOver,
                        textAlign: 'center',
                        transformOrigin: 'center center',
                        display: 'inline-block',
                      }
                  : {
                      transition: 'all ease 0.4s',
                      width: wSize,
                      textAlign: 'center',
                      transformOrigin: 'center center',
                      display: 'inline-block',
                    }
              }
            >
              {refer === 'sametime' ||
              refer === 'search' ||
              refer === 'tagSearch' ? null : isHovering ? null : (
                <em className={dRank <= 3 ? 'em_on' : null}>{dRank}</em>
              )}
              {isHovering ? (
                isMobile ? null : (
                  <Tooltip title="찜하기">
                    <div className="list_img_add">
                      <span
                        onClick={this._toggleWish}
                        style={
                          parseInt(wishFlag) > 0
                            ? {
                                background:
                                  'url(/img/add_on.png) no-repeat center center',
                              }
                            : null
                        }
                      >
                        add
                      </span>
                    </div>
                  </Tooltip>
                )
              ) : null}

              <div
                className="list_img_bg"
                style={{ cursor: 'pointer' }}
                onClick={this._onPlay}
              >
                {isHovering ? (
                  isMobile ||
                  moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                    serviceEndDate ? null : (
                    <Tooltip title="관람하기">
                      <div
                        className="list_img_play"
                        onMouseEnter={this._togglePlayOn}
                        onMouseLeave={this._togglePlayOn}
                        onClick={this._onPlay}
                      >
                        {playIcon ? (
                          <img src={imgUrl + '/img/play2.png'} />
                        ) : (
                          <img src={imgUrl + '/img/play2_off.png'} />
                        )}
                      </div>
                    </Tooltip>
                  )
                ) : null}

                {opening === null || opening === '' || opening === undefined ? (
                  <Fragment>
                    <img
                      src={isHovering ? overImg : img}
                      style={
                        isHovering
                          ? {
                              width: wSizeOver,
                              height:
                                hSizeOrver /*, transitionProperty: 'width', transitionDuration: '1s'*/,
                            }
                          : {
                              width: wSize,
                              height:
                                hSize1 /*transitionProperty: 'width', transitionDuration: '4s'*/,
                            }
                      }
                    />
                    {isHovering ? (
                      <Fragment>
                        <div className="list_title" onClick={this._onPlay}>
                          {subTitle}
                          <br />
                          바로보기
                        </div>
                        <div className="list_bg1"></div>
                      </Fragment>
                    ) : null}
                  </Fragment>
                ) : isHovering ? (
                  isMobile ? (
                    <img
                      src={img}
                      style={{
                        width: wSize,
                        height:
                          hSize1 /*transitionProperty: 'width', transitionDuration: '4s'*/,
                      }}
                    />
                  ) : (
                    <Fragment>
                      <ReactPlayer
                        url={'https://jjmp4.ofscdn.com' + opening}
                        //className='bg_img'
                        playing={true}
                        //url={playUrl}
                        volume={0.5}
                        muted={true}
                        //onReady={this._onReady}
                        //onEnded={this._onEnded}
                        //style={{width: wSize, height: hSize}}
                        width={wSizeOver - 20}
                        height={hSize}
                      />
                      <div className="list_title" onClick={this._onPlay}>
                        {subTitle}
                        <br />
                        바로보기
                      </div>
                      <div className="list_bg1"></div>
                    </Fragment>
                  )
                ) : (
                  <Fragment>
                    <img
                      src={img}
                      style={
                        isHovering
                          ? isMobile
                            ? null
                            : {
                                width: wSizeOver,
                                height:
                                  hSizeOrver /*transitionProperty: 'width', transitionDuration: '4s'*/,
                              }
                          : {
                              width: wSize,
                              height:
                                hSize1 /*transitionProperty: 'width', transitionDuration: '4s'*/,
                            }
                      }
                    />
                    {cashOnly > 0 && cashOnly !== undefined ? (
                      <div
                        style={{
                          position: 'absolute',
                          width: 70,
                          height: 22,
                          zIndex: 300,
                          bottom: 10,
                          left: 10,
                        }}
                      >
                        <img
                          src={imgUrl + '/img/bg_won.png'}
                          style={{ width: 70, height: 22 }}
                        />
                      </div>
                    ) : null}
                  </Fragment>
                )}
              </div>
              {isHovering ? (
                isMobile ? (
                  <p
                  // style={{
                  //   paddingBottom:
                  //     refer === 'search' || refer === 'tagSearch' ? 15 : 0,
                  //   whiteSpace: 'normal',
                  //   overflowWrap: 'break-word',
                  // }}
                  >
                    {title}{' '}
                    <span /*style={{fontSize: fSizeSmail}}*/>{genreName}</span>
                  </p>
                ) : (
                  <div
                    className="list_text_group"
                    style={{ cursor: 'pointer' }}
                    onClick={this._onPlay}
                  >
                    <Tooltip title="세부정보">
                      <div className="list_img_more">
                        <a>더보기</a>
                      </div>
                    </Tooltip>
                    <div
                      className="title_name"
                      style={{
                        whiteSpace: 'normal',
                        overflowWrap: 'break-word',
                      }}
                    >
                      {title}{' '}
                      <span /*style={{fontSize: fSizeSmail}}*/>
                        {restrictionCode}세&nbsp;&nbsp;|&nbsp;&nbsp;{genreName}
                        &nbsp;&nbsp;|&nbsp;&nbsp;{director}
                      </span>
                    </div>
                    <p
                      style={{
                        whiteSpace: 'normal',
                        overflowWrap: 'break-word',
                      }}
                    >
                      {parse(result.substr(0, 60))}
                      {/*
                                    <HTMLEllipsis
                                        unsafeHTML={`<p style="font-size: ${fSizeSmail}px">${contentSysnopsis}</p>`}
                                        maxLine='2'
                                        ellipsis='...'
                                        basedOn='letters'
                                        
                                    />
                                    */}
                    </p>
                  </div>
                )
              ) : (
                <p
                // style={{
                //   paddingBottom:
                //     refer === 'search' || refer === 'tagSearch' ? 15 : 0,
                //   whiteSpace: 'normal',
                //   overflowWrap: 'break-word',
                // }}
                >
                  {title}{' '}
                  <span /*style={{fontSize: fSizeSmail}}*/>{genreName}</span>
                </p>
              )}
            </div>
          )}
        </ReactHoverObserver>

        <Modal
          open={modalShow}
          showCloseIcon={false}
          onClose={this._onCloseModal}
          closeOnOverlayClick={false}
          closeOnEsc={false}
          center
          styles={{ modal: { backgroundColor: 'black' } }}
        >
          <UsePoint
            contentSerial={contentSerial}
            contentPartSerial={contentPartSerial}
            subPartSerial2={subData ? subData[0].subPartSerial2 + ',' : 0}
            subPartSerial3={subData ? subData[0].subPartSerial3 : 0}
            payGubun={payGubun}
            chksale="ppv"
            onPointUse={this._setPointUse}
            onClose={this._onCloseModal}
          />
        </Modal>

        {/* <ModalRoute
          path={`${match.url}/items/:contentSerial`}
          parentPath={match.url}
          component={Items}
        /> */}

        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}

        {/*
                <div onMouseEnter={this._onMouseToggle} onMouseLeave={this._onMouseToggle} onClick={()=>this._goItem(contentSerial)}>
                    <img src={img} draggable="false" alt="" style={onMouseOver ? styles.onZoom : styles.onNomal } />
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(ContentItem));
